function getCookie(name: string) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift();
}

export const settings = {
    projectId: 'LicenseSystem',
    title: 'app-title',
    supportTel: '09134562731',
    version: 'v0.1',
    missingTranslations: {},

    tableCellTextTruncateLength: 100,

    logMissings: () => console.log(JSON.stringify(settings.missingTranslations, null, 2)),

    getLanguageCode: () => getCookie('i18next'),
};

export default settings;
